import currencies from './currencies';

const defaultLocale = 'en-CH';
const defaultCurrency = 'USD';

export const params = document.location.search.substr(1).split('&').map(x => x.split('=', 2));

export const locales = ((navigator || {}).languages || []).concat([defaultLocale]);

export const languages = locales.map(x => x.substr(0, 2).toLowerCase());

export const language = languages[0];

export const countries = locales.map(x => x.substr(3).toUpperCase()).filter(x => x);

export const country = countries[0];

export const currency = currencies[country] || defaultCurrency;

export const client = { params, locales, languages, language, country, currency };

export function getParam(name)
{
    return (params.find(p => p[0] == name) || [])[1];
}